import { Component, Input } from '@angular/core';
import { ViewChild, ElementRef } from '@angular/core';
import { Router, Params } from '@angular/router';
import { Location } from '@angular/common';
import { Subject } from "rxjs";
import { Product, ProductResponse } from '../../../../models/Product';
import { ProductService } from '../../../../services/product.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import * as $ from 'jquery'

@Component({
  selector: 'app-product-card-edit',
  templateUrl: './product-card-edit.component.html',
  styleUrls: ['./product-card-edit.component.scss']
})
export class ProductCardEditComponent {
  @Input('product') originalProduct:Product;   //linked to parent 'products', will initially be null until products are loaded
  @ViewChild('productPrice') productPrice:ElementRef;
  sku:string = null;
  product?: Product;   //assigned a COPY so that original is maintained to check diff.
  productdate?: Date;  //store properly formatted date

  constructor(
    private router:Router,
    private productService: ProductService,
    private flashMessagesService:FlashMessagesService,
    private location: Location
  ) { }

  //TODO: Need ngOnChanges to get COPY of product to edit each time we get product
  ngOnChanges(){
    // console.log('ape - onChanges has this.product', this.product);
    //guard against null product
    if(!this.originalProduct){
      return;
    }
    this.product = Product.fromJson(this.originalProduct);  //produce an editable copy of 'product'
    this.productdate = new Date(this.originalProduct.updated_at);  //convert timestamp to Date
    //wait a tick for dom to reload with new products.
    // *all settimeout calls must use af to access 'this'.  https://stackoverflow.com/questions/41106125/angular-2-using-this-inside-settimeout
    setTimeout(() => {
      this.adjustHeightAllElements();
    }, 0);
    
  }

  adjustHeightAllElements(){
    //access DOM to modify height of the textarea
      let textareaList = Array.from(document.getElementsByTagName('textarea') as NodeListOf<HTMLElement>);
      for (let textarea of textareaList){
        // console.log('auto-sizing textarea', textarea);
        textarea.style.overflow = 'hidden';
        textarea.style.height = '0px';
        textarea.style.height = textarea.scrollHeight + 'px';
      }
  }
  
  //adjust the height of 
  adjustHeightSingleElement($e){
    console.log('textarea change detected');
    let textarea = $e.target;
    if(textarea == null){
      return;
    }
    textarea.style.overflow = 'hidden';
    textarea.style.height = '0px';
    textarea.style.height = textarea.scrollHeight + 'px';
  }




  updownclicked($event){
    // console.log('updownclicked with event', $event);
    let e0 = $event.path[0];
    let e1 = $event.path[1];
    let isUpward = $(e0).hasClass('upward') || $(e1).hasClass('upward');
    if (isUpward){
      //upward = increase value by $1
      let newprice = this.product.product_price + 1;
      this.product.product_price = +newprice.toFixed(2);
    } else {
      //downward = reduce value by $1
      let newprice = this.product.product_price - 1;
      this.product.product_price = +newprice.toFixed(2);
    }
  }


  onCancelClicked(){
    // console.log('cancel clicked');
    // flash message editing cancelled
    this.flashMessagesService.show('Cancelled product edit.  Changes not saved.', {cssClass:'alert-danger', timeout: 4000});
    this.location.back();
  }

  onDeleteClicked(){
    // console.log('delete clicked');

    this.productService.deleteProduct(this.product).first().subscribe((productResponse:ProductResponse) => {
      if(productResponse.success){
        this.flashMessagesService.show('Successfully deleted the product.', {cssClass:'alert-success', timeout:4000});
        this.router.navigate(['/admin/products']);
      } else {
        //flashmessage error
        console.log('pce: error deleting product');
        this.flashMessagesService.show(productResponse.msg, {cssClass:'alert-danger', timeout:4000});
      }
    });
  }

  onSubmit({value, valid}:{value:Product, valid:boolean}){
    // console.log('update clicked');
    if(!valid){
      this.flashMessagesService.show('Please fill in all fields', {cssClass:'alert-danger', timeout:4000});
      // this.router.navigate(['edit-client/'+this.id]);
    } else {
      //Update product
      
      this.productService.editProduct(this.product).first().subscribe((productResponse:ProductResponse) => {
        // console.log('pce: res', productResponse);
        if(productResponse.success){
          this.flashMessagesService.show('Successfully saved edits to product.', {cssClass:'alert-success', timeout:4000});
          this.router.navigate(['/products/'+this.product.category]);
        } else {
          //flashmessage error
          console.log('pce: error editing product');
          this.flashMessagesService.show(productResponse.msg, {cssClass:'alert-danger', timeout:4000});
        }

      })

      //TODO: send this.product to productService.http_productEdit.

      // this.clientService.updateClient(this.id, value);
      // this.flashMessagesService.show('Client updated', {cssClass:'alert-success', timeout:4000});
      // this.router.navigate(['/client/'+this.id]);
    }
  }

}


//-------------
//Unused Code
// let newprice = Number((this.product.product_price - 1).toFixed(2));

  // onPriceChange($e){
  //   // console.log($e);

  //   // if ([52,53].indexOf($e.keyCode) !== -1) {
  //   //   console.log('is a number');
  //   // } else {
  //   //   console.log('not a number');
  //   // }

  //   // let newValue = Number(event);
  //   // console.log(newValue);
  //   // if(isNaN(newValue)){
  //   //   console.log('must be a number');
  //   //   event.preventDefault();
  //   //   // console.log(this.productPrice.viewModel);
  //   //   // this.productPrice.nativeElement.innerHTML = "hola"
  //   // } else {
  //   //   console.log('price changed to:', newValue);
  //     this.product.product_price = newValue;
  //   // }
// 
  // }

// $('.spinner .btn:first-of-type').on('click', function() {
//   console.log('up');
//   $('.spinner input').val( parseInt($('.spinner input').val(), 10) + 1);
// });
// $('.spinner .btn:last-of-type').on('click', function() {
//   console.log('down');
//   $('.spinner input').val( parseInt($('.spinner input').val(), 10) - 1);
// });

// console.log('attempting getProductBySku', this.sku);
// console.log('did getProductBySku, attempting productFromJson with filteredProduct', filteredProduct);
// console.log('did product.fromJson');

//products are now being loaded from products.component.ts
      // //load products, since edit is not part of products.component.ts frame
      // this.productService.loadAllProducts(true);


  //This worked!  But instead decided to replace it with Input as the data stream instead of the productService single,
  // to reinforce data hierarchy.  Let products.component manage loading of the products, and then pass it to all its child components such as this one.
  // Replaced this with Input of products + ngOnChanges()
  // ngOnInit() {
  //   this.activatedRoute.params.subscribe((params: Params) => {
  //     //use route params to set local properties
  //     this.sku = params["sku"];
  //     //request products from productService
      
      
  //     //subscribe to product$, because products need time to fetch from http
  //     this.productService.product$
  //     .takeUntil(this.ngUnsubscribe)
  //     .subscribe((products) => {
  //       console.log('pce received new products', products);
  //       //guard against empty products
  //       if (products.length == 0){
  //         return;          
  //       }
  //       let filteredProduct = this.productService.getProductBySku(this.sku);
        
  //       if(filteredProduct){
  //         let filteredCopy = Product.fromJson(filteredProduct);  //to get a new product copy.
  //         this.product = filteredCopy;  //local has a copy, so we can track changes from original upon save
  //         this.productdate = new Date(this.product.updated_at);  //convert timestamp to Date
  //         setTimeout(() => {
  //           this.adjustHeightAllElements();
  //         }, 0);
  //       } else {
  //         this.product = null;
  //         this.productdate = null;
  //       }

  //     });

  //     //TODO: Rewrite this to load the product
  //     // this.productService.getProductBySku(this.sku).subscribe(product => {  
  //     //   //construct a copy of product to use for editing.
  //     //   // actual product will be updated only upon user pressing 'update' button.
  //     //   this.product = JSON.parse(JSON.stringify(product));  //use JSON to create copy of product
  //     // });
  //   });
  // }

  // //no longer needed.  Using Inputs to get the product to edit.
  // ngOnChanges(){
  //   console.log('pce received new products', this.products);
  //   //guard against empty products
  //   if (this.products.length == 0){
  //     return;          
  //   }
  //   let filteredProduct = this.productService.getProductBySku(this.sku);
    
  //   if(filteredProduct){
  //     let filteredCopy = Product.fromJson(filteredProduct);  //to get a new product copy.
  //     this.product = filteredCopy;  //local has a copy, so we can track changes from original upon save
  //     this.productdate = new Date(this.product.updated_at);  //convert timestamp to Date
  //     setTimeout(() => {
  //       this.adjustHeightAllElements();
  //     }, 0);
  //   } else {
  //     this.product = null;
  //     this.productdate = null;
  //   }
  // }


// WEBPACK FOOTER //
// ./src/app/components/products/product-card/product-card-edit/product-card-edit.component.ts